import { render, staticRenderFns } from "./OrderAudits.vue?vue&type=template&id=794b8d7e"
import script from "./OrderAudits.vue?vue&type=script&lang=js"
export * from "./OrderAudits.vue?vue&type=script&lang=js"
import style0 from "./OrderAudits.vue?vue&type=style&index=0&id=794b8d7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports